export default "__VITE_ASSET__Bc0UY6v5__";